import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../redux/store';
import { useState } from 'react';
import {
  getEvaluationResults,
  EvaluationResultAnalysisPayload,
} from '../reducers/postEvaluationResultsAnalysis';

const usePostEvaluationResultsAnalysis = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<unknown>();

  const postResultsAnalysisSurvey = async (
    requestPayload: EvaluationResultAnalysisPayload[],
  ) => {
    try {
      const resultAction = await dispatch(getEvaluationResults(requestPayload));
      if (getEvaluationResults.fulfilled.match(resultAction)) {
        setLoading(false);
      }
    } catch (error) {
      setError(error);
    }finally{
      setLoading(false)
    }
  };

  return { loading, error, postResultsAnalysisSurvey };
};

export default usePostEvaluationResultsAnalysis;